var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.525 18.0252C9.19167 18.2418 8.85417 18.2543 8.5125 18.0627C8.17083 17.871 8 17.5752 8 17.1752V6.82518C8 6.42518 8.17083 6.12935 8.5125 5.93768C8.85417 5.74602 9.19167 5.75852 9.525 5.97518L17.675 11.1502C17.975 11.3502 18.125 11.6335 18.125 12.0002C18.125 12.3669 17.975 12.6502 17.675 12.8502L9.525 18.0252Z",
    fill: "#1E96FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.532180f0172dcabbbe3502c2d8a4a4f4.svg";
export { ForwardRef as ReactComponent };